<div class="assign-dialog-container">
  <h2 mat-dialog-title class="text-xl font-semibold text-gray-900 mb-4">Add to Parking Space Group</h2>

  <div mat-dialog-content class="space-y-4">

    <!-- Operator Info -->
    <div class="bg-gray-50 p-4 rounded-lg flex items-center gap-3">
      <div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
        <mat-icon class="text-blue-600">person</mat-icon>
      </div>
      <div>
        <p class="font-medium text-gray-900">{{ operatorName }}</p>
        <p class="text-sm text-gray-500">{{ operator.email }}</p>
      </div>
    </div>

    <!-- Customer Select -->
    @if (isLoadingCustomers()) {
      <div class="flex items-center gap-2 py-2 text-gray-500">
        <mat-spinner diameter="20"></mat-spinner>
        <span class="text-sm">Loading customers...</span>
      </div>
    } @else {
      <mat-form-field class="w-full">
        <mat-label>Customer</mat-label>
        <mat-select [value]="selectedCustomerId()" (valueChange)="onCustomerSelected($event)"
          [disabled]="isSubmitting()">
          <mat-option value="">-- Select a customer --</mat-option>
          @for (customer of customers(); track customer.id) {
            <mat-option [value]="customer.id">{{ customer.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <!-- Parking Space Group Select (shown once customer is picked) -->
    @if (selectedCustomerId()) {
      @if (isLoadingGroups()) {
        <div class="flex items-center gap-2 py-2 text-gray-500">
          <mat-spinner diameter="20"></mat-spinner>
          <span class="text-sm">Loading parking space groups...</span>
        </div>
      } @else if (parkingSpaceGroups.length === 0) {
        <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-sm text-yellow-800">
          No parking space groups found for this customer.
        </div>
      } @else if (availableParkingSpaceGroups.length === 0) {
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm text-blue-800 flex items-center gap-2">
          <mat-icon style="font-size:18px;height:18px;width:18px;">info</mat-icon>
          Operator is already a member of all parking space groups for this customer.
        </div>
      } @else {
        <mat-form-field class="w-full">
          <mat-label>Parking Space Group</mat-label>
          <mat-select [value]="selectedPsoId()" (valueChange)="selectedPsoId.set($event)"
            [disabled]="isSubmitting()">
            <mat-option value="">-- Select a parking space group --</mat-option>
            @for (pso of availableParkingSpaceGroups; track pso.id) {
              <mat-option [value]="pso.id">
                <span class="font-medium">{{ pso.parkingSpace?.name ?? 'Unnamed Space' }}</span>
                <span class="text-xs text-gray-400 ml-2">{{ pso.operatorGroup?.name }}</span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    }

    <!-- Selected group preview -->
    @if (selectedParkingSpaceGroup) {
      <div class="bg-gray-50 rounded-lg p-4 space-y-1 border border-gray-100">
        <div class="flex items-center gap-2">
          <mat-icon class="text-gray-500" style="font-size:18px;height:18px;width:18px;">local_parking</mat-icon>
          <p class="font-medium text-gray-900">{{ selectedParkingSpaceGroup.parkingSpace?.name ?? 'Unnamed Space' }}</p>
        </div>
        <p class="text-sm text-gray-600 pl-6">Group: {{ selectedParkingSpaceGroup.operatorGroup?.name }}</p>
        <p class="text-xs text-gray-400 pl-6">
          Role: {{ selectedParkingSpaceGroup.operatorGroup?.role }}
          &bull; {{ selectedParkingSpaceGroup.operatorGroup?.activeMemberCount ?? 0 }}
          member{{ (selectedParkingSpaceGroup.operatorGroup?.activeMemberCount ?? 0) === 1 ? '' : 's' }}
        </p>
      </div>
    }

  </div>

  <div mat-dialog-actions class="flex gap-3 pt-2">
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting()" class="flex-1">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()"
      [disabled]="!selectedPsoId() || isSubmitting()" class="flex-1">
      {{ isSubmitting() ? 'Adding...' : 'Add to Group' }}
    </button>
  </div>
</div>